"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var Dropdown_1 = require("../dropdown/Dropdown");
var SelectStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: auto;\n  margin-bottom: 0;\n\n  li {\n    opacity: .6;\n    transition: 200ms opacity ease-out;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &[data-selected='true'] {\n      opacity: 1;\n    }\n  }\n"], ["\n  width: auto;\n  margin-bottom: 0;\n\n  li {\n    opacity: .6;\n    transition: 200ms opacity ease-out;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &[data-selected='true'] {\n      opacity: 1;\n    }\n  }\n"])));
var setOptions = function (options, onChange) {
    if (onChange === void 0) { onChange = null; }
    if (!onChange) {
        return options.map(function (option, idx) { return (0, jsx_runtime_1.jsx)("option", __assign({ value: option.value }, { children: option.name }), idx); });
    }
    else {
        return options.map(function (option, idx) { return (0, jsx_runtime_1.jsx)("li", __assign({ "data-value": option.value, "data-selected": option.selected, onClick: onChange }, { children: option.name }), idx); });
    }
};
var Select = function (_a) {
    var options = _a.options, name = _a.name, value = _a.value, selectRef = _a.selectRef, _b = _a.selectedOption, selectedOption = _b === void 0 ? null : _b, onChange = _a.onChange, _c = _a.placeholder, placeholder = _c === void 0 ? null : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    if (!options)
        return null;
    var selectElement = selectRef.current;
    var selectedName = selectElement ? selectElement.options[selectElement.selectedIndex].text : selectedOption.name;
    return ((0, jsx_runtime_1.jsxs)(SelectStyled, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)("label", __assign({ className: 'srt-only' }, { children: [placeholder && (0, jsx_runtime_1.jsx)("span", { children: placeholder }), (0, jsx_runtime_1.jsx)("select", __assign({ ref: selectRef, name: name, defaultValue: value }, { children: setOptions(options) }))] })), (0, jsx_runtime_1.jsx)(Dropdown_1.Dropdown, { options: setOptions(options, onChange), trigger: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [placeholder && (0, jsx_runtime_1.jsx)("span", __assign({ className: 'label' }, { children: placeholder })), (0, jsx_runtime_1.jsx)("span", __assign({ className: 'option-selected' }, { children: selectedName }))] }) })] })));
};
exports.Select = Select;
var templateObject_1;
